(function () {
  if (window.TpServingQuiz) return;

  var COEFFICIENT = 87;

  function parseNumber(value) {
    if (typeof value === 'number') return value;
    return Number(String(value || '').replace(',', '.'));
  }

  function formatWeight(weight) {
    return parseNumber(weight).toLocaleString('pt-BR', {
      minimumFractionDigits: Number(weight) % 1 === 0 ? 0 : 1,
      maximumFractionDigits: 1,
    });
  }

  function parsePackageWeight(value) {
    var match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*(kg|g)\b/i);
    if (!match) return null;

    var amount = parseNumber(match[1]);
    if (!amount) return null;

    return match[2].toLowerCase() === 'kg' ? amount * 1000 : amount;
  }

  function getPackageOptions(variants) {
    return (Array.isArray(variants) ? variants : [])
      .map(function (variant) {
        var label = variant?.option1 || variant?.title || '';
        var grams = parsePackageWeight(label);

        if (!label || !grams) return null;

        return { label: label, grams: grams };
      })
      .filter(Boolean)
      .sort(function (first, second) { return first.grams - second.grams; })
      .filter(function (item, index, items) { return items.findIndex(function (entry) { return entry.grams === item.grams; }) === index; });
  }

  function getPackageSummary(gramsPerDay, variants) {
    var packages = getPackageOptions(variants);
    if (!packages.length || !gramsPerDay) return '';

    var durations = packages.map(function (item) {
      var days = item.grams / gramsPerDay;
      var formattedDays = days.toLocaleString('pt-BR', {
        minimumFractionDigits: days >= 10 ? 0 : 1,
        maximumFractionDigits: 1,
      });
      var dayLabel = Math.abs(days - 1) < 0.05 ? 'dia' : 'dias';

      return item.label + ' rende ' + formattedDays + ' ' + dayLabel;
    });

    var suggestedPackage = packages.find(function (item) { return item.grams >= gramsPerDay; }) || packages[packages.length - 1];
    var suggestedQuantity =
      suggestedPackage.grams >= gramsPerDay ? 1 : Math.ceil(gramsPerDay / suggestedPackage.grams);

    return durations.join(' | ') + '. Sugestão inicial: ' + suggestedQuantity + 'x ' + suggestedPackage.label + '.';
  }

  function calculate(weightValue, variants) {
    var weight = parseNumber(weightValue);

    if (!Number.isFinite(weight) || weight <= 0) {
      return null;
    }

    var kcalPerDay = COEFFICIENT * Math.pow(weight, 0.75);
    var gramsPerDay = Math.round(((kcalPerDay * 0.5) / 600) * 1000);

    return {
      gramsPerDay: gramsPerDay,
      coefficient: COEFFICIENT,
      packageSummary: getPackageSummary(gramsPerDay, variants),
    };
  }

  window.TpServingQuiz = {
    calculate: calculate,
    formatWeight: formatWeight,
    getPackageSummary: getPackageSummary,
  };
})();
